import { mkQcsSyncResourceStore } from 'data/qcsSyncResourceTypes';
import { handleActions } from 'redux-actions';
import { upsertResources, completeWithError } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './investmentBalancesV2Actions';

const investmentBalancesV2Reducer = handleActions({

  [actions.getInvestmentBalancesV2]:
    (state) => state.merge({ isLoading: true }),
  [actions.getInvestmentBalancesV2Success]:
    (state, action) => upsertResources(state, action.payload),
  [actions.getInvestmentBalancesV2Failure]:
    (state, { payload: error }) => completeWithError(state, error),

}, mkQcsSyncResourceStore());

export const INVESTMENT_BALANCES_V2_REDUCER_KEY = 'investmentBalancesV2Store';
export default investmentBalancesV2Reducer;
